import Vue from "vue";
function showNoti(type, path, err = undefined, time = 3500) {
  const Noti = new Vue();
  Noti.$eventBus.showDropdownNoti({
    icon: type,
    title: err ? err.errorTitle : `notification.${path}.title`,
    text: err ? err.errorMessage : `notification.${path}.text`,
    duration: time
  });
}
export default { showNoti };
